import React from 'react';
import { connect } from 'react-redux';
import OlaClickLegalRepresentativeStep from './OlaClickLegalRepresentativeStep';
import OlaClickCompanyStep from './OlaClickCompanyStep';
import OlaClickTermsAndConditionsStep from './OlaclickTermsAndConditionsStep';
import SignUpReferrals from '../SignUpReferrals';
import ReferralService from '../../../../services/ReferralService';
import { getProofOfTaxSituation } from '../../../../redux/reducers/ReferralReducer';
import { getFormViewByCountry } from './ConfigByCountry';
import { withRouter } from 'react-router-dom';

const OlaClickSignUpReferralsInternal = ({ match, proofOfTaxSituation, ...props }) => {
  const { params } = match;
  const viewConfig = getFormViewByCountry(params.country);
  const onSubmit = async (values) => {
    const referral = {
      data: {
        ...values.data,
        proofOfTaxSituation,
      },
    };
    await ReferralService.signUpOlaclickReferral(referral);
  };

  return (
    <SignUpReferrals onSubmit={onSubmit} {...props}>
      <OlaClickLegalRepresentativeStep paramsForm={viewConfig.STEP_1} country={params.country} />
      <OlaClickCompanyStep paramsForm={viewConfig.STEP_2} country={params.country} />
      <OlaClickTermsAndConditionsStep />
    </SignUpReferrals>
  );
};

const mapStateToProps = (state) => {
  return {
    proofOfTaxSituation: getProofOfTaxSituation(state),
  };
};

export const OlaClickSignUpReferrals = withRouter(connect(mapStateToProps)(OlaClickSignUpReferralsInternal));
